export const bearerAuthorizationHeader = token => ({
    headers: { Authorization: `Bearer ${token}` }
});